import { lazy } from 'react';
import { retry } from '../../config/utils';

const Register = lazy(() =>  retry(()=> import(/* webpackChunkName: "register" */ "./indexv2")));

export default Register;